import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPlayer from 'react-player'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { VideoCarousel } from 'components/VideosCarousel'

import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
}

const BecomeSection: FC<IProps> = props => {
  const [isClickPlay, setIsClickPlay] = useState(false)
  // const [playingVideo, setPlayingVideo] = useState('https://youtu.be/L0JpVc3W-Mc?si=Tk3iWRyPB_uUqjk7')

  // const onClickVideo = useCallback((value: string) => {
  //   setPlayingVideo(value)
  // }, [])

  const handleClickPlay = () => {
    setIsClickPlay(true)
  }

  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.becomeContainer}>
          <TitleSection title={'Become a Creator in Somnium Space'}
                        subTitle={'Empower Your Creativity with the Creators Fund'}/>
          <div className={styles.middleBlock}>
            <div className={styles.description}>
              <img src={staticMultimedia.creatorsFundLogo} alt="creators"/>
              <div>
                Welcome to the realm of limitless imagination and artistic ingenuity within Somnium Space. Here, the
                Creators Fund ignites the spark of innovation, providing a stage for your groundbreaking ideas to
                flourish.
                Immerse yourself in a journey akin to the brightest minds of the metaverse on a quest to manifest the
                extraordinary. Witness the visions of our Creators Fund winners come to life through captivating videos
                that showcase their masterpieces and accomplishments.
                <br/><br/>
                But the journey doesn't end there. You too can step into the spotlight and become a part of this vibrant
                community. Unleash your creativity, unleash your potential, and join a community that embraces your
                uniqueness.
                Whether it's crafting awe-inspiring worlds, designing breathtaking artworks, or bringing visionary
                experiences to life, Somnium Space is your canvas. Join us, become a creator, and share your passion
                with
                the world. Let your journey begin.
              </div>
            </div>

            <div className={styles.videoBlock}>
              <div className={cn({
                [styles.videoPlayerWrapper]: true
              })}>
                <ReactPlayer
                  url={'https://youtu.be/L0JpVc3W-Mc?si=Tk3iWRyPB_uUqjk7'}
                  className={styles.reactPlayer}
                  volume={0}
                  playing={false}
                  loop
                  muted
                  playsinline
                  width="100%"
                  height="100%"
                  onPlay={handleClickPlay}
                  config={{
                    file: {
                      attributes: {
                        preload: 'metadata'
                      }
                    },
                    youtube: {
                      playerVars: {
                        controls: 1
                        // origin: process.env.REACT_APP_YOUTUBE_ORIGIN_URL
                      }
                    }
                  }}
                />
                {!isClickPlay
                  ? <div className={styles.videoTitleBox}>
                    <div className={styles.videoTitle}>
                      Improved Base Reality World & Weather System
                    </div>
                  </div>
                  : null}
              </div>

              {/*<VideoCarousel playingVideo={playingVideo} onClick={onClickVideo}/>*/}
            </div>

          </div>
          <div className={styles.bottomBlock}>
            <TitleBottomSection
              title={'Start Your Journey as a Somnium Space Creator Today, become part of vibrant'}
              subTitle={'Somnium Space community, and turn your dreams into reality. Join now to create, share, and thrive in a metaverse filled with endless possibilities. Your masterpiece awaits.'}/>
            <div className={styles.rightBox}>
              <ButtonMUI styleType={'white'}
                         onClick={() => window.open('https://discord.com/invite/somniumspace', '_blank', 'noopener,noreferrer')}
                         type="button"
                         sx={{
                           '&&': {
                             width: '215px',
                             height: '60px',
                             borderRadius: '30px'
                           }
                         }}>Join our Discord</ButtonMUI>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(BecomeSection)
